import { render, staticRenderFns } from "./popupVideo.vue?vue&type=template&id=1197bd01&scoped=true"
import script from "./popupVideo.vue?vue&type=script&lang=js"
export * from "./popupVideo.vue?vue&type=script&lang=js"
import style0 from "./popupVideo.vue?vue&type=style&index=0&id=1197bd01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1197bd01",
  null
  
)

export default component.exports